<template>
  <div class="map_box1">
    <mapHeader></mapHeader>

    <div style="width:240px;padding:0 20px;">
      <el-select style="width:240px;" v-model="tab_active_name" placeholder="请选择" @change="toggle_tabs">
        <el-option v-for="(o,i) in tab_name_list" :key="i" :label="o.label" :value="o.value">
        </el-option>
      </el-select>
    </div>

    <div id="map_subject2">
      <div>
        <div class="title">
          <p>个人年龄文化分析</p>
          <p>单位：人</p>
        </div>
        <div id="echarts1"></div>
        <div class="Legend1">
          <p v-for="(o,i) of  echarts1_data[3]" :key="o.id">
            <i :style="{background:echarts1_data[0][i]}"></i>
            <span>{{o}}</span>
          </p>
        </div>
        <div class="Legend2">
          <p v-for="(o,i) of  echarts1_data[4]" :key="o.id">
            <i :style="{background:echarts1_data[1][i]}"></i><span>{{o}}</span>
          </p>
        </div>
      </div>
      <div>
        <div class="title">
          <p>个人就业方式分析</p>
          <p>单位：人</p>
          <div class="Legend">
            <p v-for="(o,i) of  echarts2_data[0]" :key="o.id">
              <i :style="{background:echarts2_data[2][i]}"></i>
              <span>{{o}}</span>
            </p>
          </div>
        </div>
        <div id="echarts2"></div>
      </div>
      <div>
        <div class="title">
          <p>个人就业群体分布</p>
          <p>单位：人</p>
          <div class="Legend">
            <p v-for="(o,i) of  echarts3_data[0]" :key="o.id">
              <i :style="{background:echarts3_data[2][i]}"></i>
              <span>{{o}}</span>
            </p>
          </div>
        </div>
        <div id="echarts3"></div>
      </div>
      <div>
        <div class="title">
          <p>个人就业区域分析</p>
          <p>单位：人</p>
          <div class="Legend">
            <p v-for="(o,i) of  echarts4_data[0]" :key="o.id">
              <i :style="{background:echarts4_data[2][i]}"></i>
              <span>{{o}}</span>
            </p>
          </div>
        </div>
        <div id="echarts4"></div>
      </div>
      <div>
        <div class="title">
          <p>单位招聘需求分析</p>
          <!-- <div class="screen">
            <el-select v-model="education_text"  @change="change_education_id" popper-class="ty-select-opt" placeholder="请选择">
              <el-option v-for="o in education_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
            <el-select v-model="age_text"  @change="change_age_text_id" popper-class="ty-select-opt"  placeholder="请选择">
              <el-option v-for="o in age_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
            <el-select   v-model="salary_text"  @change="change_salary_text_id" popper-class="ty-select-opt" placeholder="请选择">
              <el-option v-for="o in salary_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
          </div> -->
          <div class="Legend">
            <p v-for="(o,i) of echarts5_data[0]" :key="o.id">
              <i :style="{background:echarts5_data[2][i]}"></i>
              <span>{{o}}</span>
            </p>
          </div>
          <p class="Company">单位：人</p>
        </div>
        <div id="echarts5"></div>
      </div>
      <div>
        <div class="title">
          <p>供求结构体系分析</p>
          <!-- <div class="screen">
            <el-select v-model="a_education_text"  @change="change_education_id_a" popper-class="ty-select-opt"  placeholder="年龄">
              <el-option v-for="o in education_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
            <el-select v-model="a_age_text"  @change="change_age_text_id_a" popper-class="ty-select-opt"  placeholder="年龄">
              <el-option v-for="o in age_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
            <el-select v-model="a_salary_text"  @change="change_salary_text_id_a" popper-class="ty-select-opt" placeholder="薪酬">
              <el-option v-for="o in salary_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
            <el-select v-model="region_text" @change="region_text_id"  popper-class="ty-select-opt" placeholder="区域">
              <el-option v-for="o in region_text_data" :key="o.value" :label="o.label" :value="o.value"></el-option>
            </el-select>
          </div> -->
          <div class="Legend">
            <p v-for="(o,i) of echarts6_data[3]" :key="o.id">
              <i :style="{background:echarts6_data[2][i]}"></i>
              <span>{{o}}</span>
            </p>
          </div>
          <p class="Company">单位：人</p>
        </div>
        <div id="echarts6"></div>
      </div>
    </div>
    <div class="main-footer">
      <span>版权所有 ©成都竞成人力资源服务股份有限公司</span>&nbsp;
      <span>蜀ICP备11025845号 蜀ICP备11025845号-1</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab_active_name: 'jzfp',        // 当前tab
      tab_name_list: [
        {label:'脱贫人口就业监测',value:'jzfp'},
        // {label:'单位岗位招聘监测',value:'gwzp'},
        // {label:'劳动维权预警监测',value:'ldwq'},
        {label:'高校学生就业监测',value:'gxxs'},
        {label:'退役军人就业监测',value:'tyjr'},
        {label:'残疾人士就业监测',value:'cjrs'},
        {label:'退捕渔民就业监测',value:'tbym'},
        // {label:'其他人员就业监测',value:'qtry'},
      ],

      li_list: [
        { id: 'echarts1', type: 0 },
        { id: 'echarts2', type: 1 },
        { id: 'echarts3', type: 2 },
        { id: 'echarts4', type: 3 },
        { id: 'echarts5', type: 4 },
        { id: 'echarts6', type: 5 }
      ],
      echarts1_data:[
        ['#B0B2BB','#655CC7','#E81B6D','#D847A7','#5B5310'],
        ['#CA5857','#6EC245','#DDD05E','#477BD8'],
        ['高中以下','中专','大专','本科','硕士以上','18-30','31-40','41-50','51-60'],
        ['高中以下','中专','大专','本科','硕士以上',],
        ['18-30','31-40','41-50','51-60']
      ],
      echarts2_data: [
        ['单位就业', '灵活就业', '扶贫车间', '公益岗位', '自由创业', '其它职业'],
        [1020, 5332, 20033, 33334, 33390, 33330,],
        ['#CA5857', '#B0B2BB', '#6EC245', '#477BD8', '#655CC7', '#E81B6D']
      ],
      echarts3_data: [
        ['贫困人员', '高校毕业生', '退役军人', '残疾人士', '退捕渔民', '其它人员'],
        [1020, 532, 330, 30, 230, 3334],
        ['#CA5857', '#6EC245', '#477BD8', '#E81B6D', '#655CC7', '#DDD05E']
      ],
      echarts6_data: [
        [],
        [],
        ['#CA5857', '#B0B2BB', '#6EC245', '#477BD8', '#DDD05E', '#655CC7', '#E81B6D'],
        ['招聘人数','求职人数']
      ],
      echarts5_data: [
        ['县内','县外省内','珠三角','京津冀','长三角','其它'],
        [],
        ['#CA5857', '#B0B2BB', '#6EC245', '#477BD8', '#DDD05E', '#655CC7', '#E81B6D']
      ],
      echarts4_data: [
        ['县内', '县外省内', '珠三角', '长三角', '京津冀', '境外', '其它'],
        [
          { value: 10, name: '县内' },
          { value: 5, name: '县外省内' },
          { value: 15, name: '珠三角' },
          { value: 25, name: '长三角' },
          { value: 20, name: '京津冀' },
          { value: 35, name: '境外' },
          { value: 35, name: '其它' },
        ],
        ['#CA5857', '#B0B2BB', '#6EC245', '#477BD8', '#DDD05E', '#655CC7', '#E81B6D']
      ],
      education_data: [
        { value: 1, label: '高中以下' },
        { value: 2, label: '中专' },
        { value: 3, label: '专科' },
        { value: 4, label: '本科' },
        { value: 5, label: '硕士以上' },
        { value: 6, label: '其它' }
      ],
      age_data: [
        { value: 1, label: '18-30' },
        { value: 2, label: '31-40' },
        { value: 3, label: '41-50' },
        { value: 4, label: '51-60' },
        { value: 5, label: '其它' },
      ],
      salary_data:[
        { value: 1, label: '3000以下' },
        { value: 2, label: '3001-4000' },
        { value: 3, label: '4001-5000' },
        { value: 4, label: '5001-6000' },
        { value: 5, label: '6000以上' },
        { value: 99, label: '其它' },
      ],
      region_text_data:[
        { value: 1, label: '县内' },
        { value: 2, label: '县外省内' },
        { value: 3, label: '珠三角' },
        { value: 4, label: '长三角' },
        { value: 5, label: '京津冀' },
        { value: 6, label: '境外' },
        { value: 7, label: '其它' },
        { value: 8, label: '空' }
      ],
      value: '',
      data: {},
      id: '',
      education_text: '高中以下',
      age_text: '18-30',
      salary_text: '3000以下',
      a_education_text: '高中以下',
      a_age_text: '18-30',
      a_salary_text: '3000以下',
      region_text: '县内',
      salaryType: 1,
      ageType: 1,
      educationType: 1,
      region_id: 1,
      month_data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
    }
  },
  methods: {
    // 点击tabs 切换
    toggle_tabs(val) {
      console.log('%cval:', 'color: #0f0;', val)
      this.tab_active_name = val

      const rDate = { areaId: this.id }
      switch (this.tab_active_name) {
        case 'jzfp': rDate.jobGroup = '贫困人员'; break;
        case 'gxxs': rDate.jobGroup = '高校毕业生'; break;
        case 'tyjr': rDate.jobGroup = '退役军人'; break;
        case 'cjrs': rDate.jobGroup = '残疾人'; break;
        case 'tbym': rDate.jobGroup = '退捕渔民'; break;
        case 'qtry': rDate.jobGroup = '其它失业人员'; break;
        default: console.log('jzfp'); break;
      }
      console.log('%cswiper-rDate:', 'color: #f0f;', rDate)
      return this.$api.mapSummation(rDate).then(_res => {
        if (_res.data.status === 0) {
          const _D = JSON.parse(_res.data.data)
          this.progress_bar_handler(_D)
          this.data = _D
          this.initPage(this.data)
        } else {
          this._status(_res.data)
        }
      })
    },
    // 设置左侧进度条
    progress_bar_handler(data) {
      console.log('%c左侧进度条:', 'color: #0ff;', data)
      let {
        haveJob, noJobNoWish, noJobHaveWish,
        dealLostSalary, notDealLostSalary,
        needPersons, workPersons, emptyWorkPersons,
        hiStudentHasJob, hiStudentNoJobNoWish, hiStudentNoJobHaveWish,
        soldierHasJob, soldierNoJobNoWish, soldierNoJobHaveWish,
        disableHasJob, disableNoJobNoWish, disableNoJobHaveWish,
        fishManHasJob, fishManNoJobNoWish, fishManNoJobHaveWish,
        lostJobHasJob, lostJobNoJobNoWish, lostJobNoJobHaveWish,
      } = data

      let ldwqAll = haveJob + noJobNoWish + noJobHaveWish // 监测总人数=脱贫劳动力
      let ldwqEarlyWarning = dealLostSalary + notDealLostSalary // 预警总人数=已解决总人数+待解决总人数
      let hiStudentAll = hiStudentHasJob + hiStudentNoJobNoWish + hiStudentNoJobHaveWish // 
      let soldierAll = soldierHasJob + soldierNoJobNoWish + soldierNoJobHaveWish // 
      let disableAll = disableHasJob + disableNoJobNoWish + disableNoJobHaveWish // 
      let fishManAll = fishManHasJob + fishManNoJobNoWish + fishManNoJobHaveWish // 
      let lostJobAll = lostJobHasJob + lostJobNoJobNoWish + lostJobNoJobHaveWish // 
      
      data.ldwqAll = ldwqAll
      data.ldwqEarlyWarning = ldwqEarlyWarning
      data.hiStudentAll = hiStudentAll
      data.soldierAll = soldierAll
      data.disableAll = disableAll
      data.fishManAll = fishManAll
      data.lostJobAll = lostJobAll
    },


    created_bra({id, data}) {
      let vm = this
      var myChart = vm.echarts.init(document.getElementById(id))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '20',
          left: '3%',
          right: '4%',
          height: '82%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            //强制显示全部X轴数据
            axisLabel: {
              interval: 0
            },
            data: Array.from(data[0]),
            axisTick: {
              show: true,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: '#1be1fe',
                width: 1
              }
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            show: true,
            axisLine: {
              lineStyle: {
                color: '#1be1fe',
                width: 1
              }
            },
            splitLine: {
              show: true,
              interval: 1,
              lineStyle: {
                color: ['#1be1fe'],
                type: 'dashed',
                opacity: 0.5
              }
            },
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: '60%',
            data: data[1],
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = data[2]
                  return colorList[params.dataIndex]
                },
                label: {
                  formatter: '{c}' + '人',
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: 'white',
                    fontSize: 12
                  }
                }
              },
            }
          }
        ]
      }
      myChart.setOption(option)
    },
    created_Broken_line() {
      let vm = this
      var myChart = vm.echarts.init(document.getElementById('echarts6'))
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '20',
          left: '3%',
          right: '4%',
          height: '82%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: [
          {
            type: 'category',
            //强制显示全部X轴数据
            axisLabel: {
              interval: 0
            },
            data:vm.month_data,
            axisTick: {
              show: true,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: '#1be1fe',
                width: 1
              }
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            show: true,
            axisLine: {
              lineStyle: {
                color: '#1be1fe',
                width: 1
              }
            },
            splitLine: {
              show: true,
              interval: 1,
              lineStyle: {
                color: ['#1be1fe'],
                type: 'dashed',
                opacity: 0.5
              }
            },
          },
        ],
        series: [
          { name: '需要人数', type: 'line', stack: '总量', data: vm.echarts6_data[0] },
          { name: '求职人数', type: 'line', stack: '总量', data: vm.echarts6_data[1] },
        ]
      }
      myChart.setOption(option)
    },
    createdPie_chart() {
      let vm = this
      var myChart = vm.echarts.init(document.getElementById('echarts4'))
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        calculable: true,
        series: [
          {
            name: '面积模式',
            type: 'pie',
            radius: [20, 70],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  color: '#1be1fe',
                  formatter: '{b} : {c} \n ({d}%)'
                },
                labelLine: {
                  show: true,
                }
              },
            },
            color: vm.echarts4_data[2],
            data: vm.echarts4_data[1],
          }
        ]
      }
      myChart.setOption(option)
    },
    created_nesting() {
      let vm = this
      var myChart = vm.echarts.init(document.getElementById('echarts1'))
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        series: [
          {
            name: '学历',
            type: 'pie',
            selectedMode: 'single',
            radius: ['60%', '72%'],
            color: vm.echarts1_data[0],
            label: {
              normal: {
                position: '',
                fontSize: 12,
                formatter: '{b} : {c}人',
                fontFamily: 'Microsoft Yahei',
                color: '#1be1fe',
              }
            },
            data: [
              {value: vm.data.educationHighSchool, name: '高中以下'},
              {value: vm.data.educationSecondary, name: '中专'},
              {value: vm.data.educationUniversity3, name: '大专'},
              {value: vm.data.educationUniversity4, name: '本科'},
              {value: vm.data.educationMaster, name: '硕士以上'},
            ]
          },
          {
            name: '年龄',
            type: 'pie',
            radius: ['10%', '50%'],
            color: vm.echarts1_data[1],
            label: {
              normal: {
                position: 'inside',
                align: 'right',
                fontSize: 12,
                formatter: '{b} \n {c}人',
                fontFamily: 'Microsoft YaHei',
                color: '#1be1fe'
              }
            },
            data: [
              {value: vm.data.ageRange18To30, name: '18-30'},
              {value: vm.data.ageRange31To40, name: '31-40'},
              {value: vm.data.ageRange41To50, name: '41-50'},
              {value: vm.data.ageRange51To60, name: '51-60'},
            ]
          },
        ]
      }
      myChart.setOption(option)
    },
    get_needsRecruitment() {
      let vm = this
      return vm.$api.needsRecruitment({areaId:vm.id,salaryType:vm.salaryType,ageType:vm.ageType,educationType:vm.educationType}).then(_res => {
        if (_res.data.status === 0) {
          let  data = JSON.parse(_res.data.data)
          vm.echarts5_data[1][0] = data['县内']
          vm.echarts5_data[1][1] = data['境外']
          vm.echarts5_data[1][2] = data['珠三角']
          vm.echarts5_data[1][3] = data['京津冀']
          vm.echarts5_data[1][4] = data['长三角']
          vm.echarts5_data[1][5] = data['其它']
          vm.created_bra({id: 'echarts5', data: vm.echarts5_data})
        } else {
          this._status(_res.data)
        }
      })
    },
    // change_education_id(data) {
    //   this.salaryType = data
    //   this.get_needsRecruitment()
    // },
    // change_age_text_id(data) {
    //   this.ageType = data
    //   this.get_needsRecruitment()
    // },
    // change_salary_text_id(data) {
    //   this.educationType = data
    //   this.get_needsRecruitment()
    // },
    // change_education_id_a(data) {
    //   this.salaryType = data
    // },
    // change_age_text_id_a(data) {
    //   this.ageType = data
    // },
    // change_salary_text_id_a(data) {
    //   this.educationType = data
    // },
    // region_text_id(data) {
    //   this.region_id = data
    // },
    Supply_and_demand_structure() {
      let vm = this
      return vm.$api.get_Supply_and_demand_structure({
        areaId:vm.id,
        salaryType:vm.salaryType,
        ageType:vm.ageType,
        educationType:vm.educationType,
        areaType:vm.region_id
      }).then(_res => {
        if (_res.data.status === 0) {
          let data = JSON.parse(_res.data.data)
          this.month_data = Object.keys(data)
          vm.$api.poorLabor_Supply_and_demand_structure({
            areaId:vm.id,
            salaryType:vm.salaryType,
            ageType:vm.ageType,
            educationType:vm.educationType,
            areaType:vm.region_id
          }).then(result => {
            if (result.data.status === 0) {
              let data_list = JSON.parse(result.data.data)
              vm.month_data.forEach(o => {
                o in data ? vm.echarts6_data[0].push(data[o]) : vm.echarts6_data[0].push(0)
                o in data_list ? vm.echarts6_data[1].push(data_list[o]) : vm.echarts6_data[1].push(0)
              })
              vm.created_Broken_line()
            } else {
              this._status(res.data)
            }
          })
        } else {
          this._status(_res.data)
        }
      })
    },

    async initPage(data) {
      this.get_needsRecruitment()
      this.Supply_and_demand_structure()

      this.echarts2_data[1][0] = data.jobOranization
      this.echarts2_data[1][1] = data.jobFlexible
      this.echarts2_data[1][2] = data.jobWorkshop
      this.echarts2_data[1][3] = data.jobPublicWelfare
      this.echarts2_data[1][4] = data.jobPioneer
      this.echarts2_data[1][5] = data.jobOther
      
      this.echarts3_data[1][0] = data.ldwqAll
      this.echarts3_data[1][1] = data.hiStudentAll
      this.echarts3_data[1][2] = data.soldierAll
      this.echarts3_data[1][3] = data.disableAll
      this.echarts3_data[1][4] = data.fishManAll
      this.echarts3_data[1][5] = data.lostJobAll
      
      this.echarts4_data[1][0].value = data.jobAreaCounty
      this.echarts4_data[1][1].value = data.jobAreaProvinceIn
      this.echarts4_data[1][2].value = data.jobAreaZhu3
      this.echarts4_data[1][3].value = data.jobAreaLong3
      this.echarts4_data[1][4].value = data.jobAreaJJArea
      this.echarts4_data[1][5].value = data.jobAreaOutside
      this.echarts4_data[1][6].value = data.jobAreaOther
      
      this.created_bra({id: 'echarts2', data: this.echarts2_data})
      this.created_bra({id: 'echarts3', data: this.echarts3_data})
      this.createdPie_chart()
      this.created_nesting()
    },
  },
  created() {
    this.data = JSON.parse(localStorage.getItem('data'))
    console.log('%cdata:', 'color: #0ff;', this.data)
    this.id = JSON.parse(localStorage.getItem('id'))
    this.initPage(this.data)
  },
  // mounted() {
  //   this.created_bra({id: 'echarts2', data: this.echarts2_data})
  //   this.created_bra({id: 'echarts3', data: this.echarts3_data})
  //   this.createdPie_chart()
  //   this.created_nesting()
  // }
}
</script>

<style lang="scss" scoped>
@import "../publicStyle/map2.css";

/deep/ .el-input__inner {
  background: transparent;color:rgb(27, 225, 254);;border: none;
  font-size: 18px;letter-spacing: .2rem;margin: 0 auto;text-align: center;
}
</style>